<template>
  <div class="customer-service-portal">
    <!-- Header with portal-specific styling -->
    <div :class="[portalType === 'lender' ? 'bg-lender-secondary' : 'bg-customer-secondary', 'py-6 px-4']">
      <div class="max-w-7xl mx-auto">
        <!-- Back button with portal-specific styling -->
        <div class="mb-4">
          <button 
            @click="goBack" 
            :class="[
              portalType === 'lender' ? 'text-lender hover:bg-lender-secondary' : 'text-customer hover:bg-customer-secondary',
              'flex items-center bg-white rounded-md px-4 py-2 shadow-sm transition-colors'
            ]"
          >
            <span class="mr-2">&larr;</span> Back
          </button>
        </div>
        
        <!-- Portal header content -->
        <div class="flex items-center justify-center flex-col">
          <div 
            class="w-16 h-16 flex items-center justify-center rounded-full mb-4" 
            :class="[portalType === 'lender' ? 'bg-lender' : 'bg-customer']"
          >
            <slot name="icon">
              <img 
                v-if="icon" 
                :src="icon" 
                :alt="title" 
                class="w-8 h-8 text-white"
              />
            </slot>
          </div>

          <h1 class="text-2xl md:text-3xl font-bold mb-2 text-center" :class="[portalType === 'lender' ? 'text-lender' : 'text-customer']">
            {{ title }}
          </h1>
          
          <p class="text-gray-600 text-center max-w-3xl">
            <slot name="description">{{ description }}</slot>
          </p>
        </div>
      </div>
    </div>

    <!-- Main content area -->
    <div class="max-w-7xl mx-auto px-4 py-8">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const props = defineProps({
  portalType: {
    type: String,
    default: 'customer',
    validator: (value) => ['lender', 'customer'].includes(value)
  },
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: 'We\'re here to help you with all your service needs.'
  },
  icon: {
    type: String,
    default: ''
  },
  backRoute: {
    type: [String, Object],
    default: null
  }
});

const router = useRouter();

const goBack = () => {
  if (props.backRoute) {
    router.push(props.backRoute);
  } else if (window.history.length > 1) {
    router.back();
  } else {
    // Fallback to customer service main page if no history
    router.push({ name: 'customerServicePage' });
  }
};
</script>

<style scoped>
.customer-service-portal {
  min-height: calc(100vh - 100px); /* Adjust based on your header/footer height */
}
</style> 